import {
  Navigate,
  Outlet,
  useLocation,
  useSearchParams,
} from 'react-router-dom';

import { FullscreenLoader } from '@/shared/components/FullscreenLoader';
import { PATHS } from '@/shared/constants/app/routes.constant.ts';
import { useAuth } from '@/features/auth';
import {
  resolveRedirectTarget,
  REDIRECT_PARAM,
  type RedirectStateFrom,
} from '@/shared/libs/redirect';

interface GuestGuardProps {
  /** 복귀 대상이 없을 때 이동할 기본 경로 */
  redirectTo?: string;
}

interface LocationState {
  from?: RedirectStateFrom;
}

/**
 * 비인증(Guest) 전용 Guard
 * - 로그인한 유저가 접근하면 이동 (from 있으면 우선 복귀, 없으면 redirectTo)
 * - 미로그인 유저만 통과 (로그인 페이지 등에 사용)
 */
export default function GuestGuard({
  redirectTo = PATHS.STORE,
}: GuestGuardProps) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  if (loading) return <FullscreenLoader />;

  if (isAuthenticated) {
    const target = resolveRedirectTarget({
      stateFrom: (location.state as LocationState | null)?.from,
      queryFrom: searchParams.get(REDIRECT_PARAM),
      fallback: redirectTo,
    });
    return <Navigate to={target} replace />;
  }

  return <Outlet />;
}
